// FIXME: 全体：アロー関数使ってください。（梅田）
import {
  $,
  addClass,
  removeClass,
  prop,
  on,
  change,
  attr,
  removeAttr,
} from 'dom7';
import {
  FormGroup,
  FormControl,
  required,
  trim,
  toHalfWidth,
} from 'reservation-frontend-commons';
import { activateNextButton } from '../utils/functions';

$.fn.addClass = addClass;
$.fn.removeClass = removeClass;
$.fn.prop = prop;
$.fn.on = on;
$.fn.change = change;
$.fn.attr = attr;
$.fn.removeAttr = removeAttr;

/**
 * 初期表示
 */
document.addEventListener(
  'DOMContentLoaded',
  () => {
    const formGroup = new FormGroup({
      controls: {
        birthYear: new FormControl({
          target: 'select[name="birthYear"]',
          validators: [required],
          event: 'blur change',
        }),
        birthMonth: new FormControl({
          target: 'select[name="birthMonth"]',
          validators: [required],
          event: 'blur change',
        }),
        birthDate: new FormControl({
          target: 'select[name="birthDate"]',
          validators: [required],
          event: 'blur change',
        }),
        telNo: new FormControl({
          target: 'input[name="telNo"]',
          validators: [required],
          converters: [trim, toHalfWidth],
          event: 'blur',
        }),
        reservationNo: new FormControl({
          target: 'input[name="reservationNo"]',
          validators: [required],
          converters: [trim, toHalfWidth],
          event: 'blur',
        }),
      },
    });
    const validateTargets = Object.keys(formGroup.controls).map(
      (key) => formGroup.controls[key]._target
    );
    activateButton(validateTargets);
  },
  false
);

const activateButton = (targets) => {
  targets.forEach((target) => {
    $(target).on('keyup change', () => {
      const validated = targets.map((t2) => $(t2).val()).filter((e) => e);
      activateNextButton(validated.length === targets.length);
    });
  });
};
